import React, { useEffect, useState } from 'react';

const ClosedCases = () => {
return (
    <div className="dashboard-container">
        <p>Page under development. Please check back later</p>
    </div>
);
}
export default ClosedCases;